export default __webpack_public_path__ + "static/media/YFS.821dc486.jpg";